import { render, staticRenderFns } from "./clinic-qr-landing.vue?vue&type=template&id=4a003f31&scoped=true"
import script from "./clinic-qr-landing.vue?vue&type=script&lang=js"
export * from "./clinic-qr-landing.vue?vue&type=script&lang=js"
import style0 from "./clinic-qr-landing.vue?vue&type=style&index=0&id=4a003f31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a003f31",
  null
  
)

export default component.exports